import { render, staticRenderFns } from "./ProductPropertiesSelector.vue?vue&type=template&id=2360eef8&scoped=true"
import script from "./ProductPropertiesSelector.vue?vue&type=script&lang=js"
export * from "./ProductPropertiesSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductPropertiesSelector.vue?vue&type=style&index=0&id=2360eef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360eef8",
  null
  
)

export default component.exports